import React, { Component } from 'react';
import history from 'dashboard/history';
import PreLoader from 'components/PreLoader/PreLoader.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import Button from 'components/Button/Button.react';
import Fieldset from 'components/Fieldset/Fieldset.react';
import styles from './Styles.scss';
import stylesSettings from 'dashboard/Settings/Settings.scss';

export default class Export extends Component {
  state = {
    loading: false,
  }

  onCloseClick() {
    history.push(`/account/info`);
  }

  render() {
    const classes = [stylesSettings.settings_page, stylesSettings.default];

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.props.section} subsection={'Export'}>
          <Button value='Go Back' onClick={this.onCloseClick} />
        </Toolbar>
        <PreLoader loading={this.state.loading}>
          <div className={stylesSettings.holder}>
            <Fieldset
              legend='Right to data portability'>
              <div className={stylesSettings.settingsBox}>
                <div className={[stylesSettings.infoBox, styles.box].join(' ')}>
                  <p>From here, you can request file containing the personal data you entered into the account and submit it to another Personal Data Administrator.</p>

                  <p>What you need to do:</p>

                  <ol>
                    <li>Download the <a href="http://public-docs.cloudstrap.io/gdpr/forms/exemplary_form_for_request_for_portability_of_personal_data.pdf" target="_blank" rel='noreferrer noopener'>Exemplary form for request for portability of personal data</a></li>
                    <li>Send the completed form correctly to support@sashido.io with a subject: <strong>Request for portability of personal data</strong></li>
                  </ol>

                </div>
              </div>
            </Fieldset>
          </div>
        </PreLoader>
      </div>
    );
  }
}
